import BaseNotification from '../BaseNotification'

export default class PassengerCancelled extends BaseNotification {
  get iconClass(): string {
    return 'sc-icon-calendar-expire'
  }
}
